// extracted by mini-css-extract-plugin
module.exports = {"cls1":"BlankSlate-BlankSlateTitle-module--cls1--1WV7d","cls2":"BlankSlate-BlankSlateTitle-module--cls2--25vkJ BlankSlate-BlankSlateTitle-module--cls1--1WV7d my-4"};